export const TYPE = 'type';
export const PROPERTY_NAME = 'propertyName';
export const VALUE = 'value';